
import { go } from '../../libs/router'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import store from '../../vuex/store'
export default {
components: {
Tab,
TabItem,
FormPreview,
Confirm,
CellFormPreview,
Group,
Alert,
Loading
},
methods: {
getById ( fplx, index ) {
return fplx + index
},
touchStart ( e ) {
this.startPos = e.touches[0].pageX
},
touchMove ( e ) {
this.endPos = e.touches[0].pageX
this.isMoved = true
},
touchEnd ( index, fplx, id, e ) {
if ( this.startPos > ( -this.endPos ) && ( this.startPos - this.endPos ) > 75 && this.isMoved ) {
if ( this.index !== -1 && this.fplx !== '' ) {
document.getElementById( this.fplx + this.index ).setAttribute( 'class', 'item' )
}
this.index = index
this.fplx = fplx
document.getElementById( fplx + index ).setAttribute( 'class', 'item selected' )
} else if ( this.endPos > this.startPos && ( this.endPos - this.startPos ) > 75 && this.isMoved ) {
if ( this.index !== -1 && this.fplx !== '' ) {
document.getElementById( this.fplx + this.index ).setAttribute( 'class', 'item' )
}
this.index = -1
this.fplx = ''
} else if ( e.target.className !== 'remove' && !this.isMoved ) {
this.onClick( '/dzfppz/' + id )
}
this.isMoved = false
},
onClick ( link ) {
go( link, this.$router )
},
onCancel () {
console.log( 'on cancel' )
},
qiehuan ( fplx ) {
if ( this.index !== -1 && this.fplx !== '' ) {
document.getElementById( this.fplx + this.index ).setAttribute( 'class', 'item' )
}
this.cw_type = fplx
this.index = -1
this.fplx = ''
},
deleteItem ( e, item, index ) {
this.confirmStatus = true
this.delId = item.id
this.confirmList = [{
label: '开票企业',
value: item.invoiceBuyerName
},
{
label: '发票号码',
value: item.invoiceNo
},
{
label: '发票金额',
value: '¥' + item.invoiceTotalAmount.toFixed( 2 )
}]
},
onConfirm () {
if ( this.index !== -1 && this.fplx !== '' ) {
document.getElementById( this.fplx + this.index ).setAttribute( 'class', 'item' )
}
var _this = this
_this.$ajax.post( _this.ajaxFactory.get( 'invoiceDelete' ), {}, {
params: {
invoiceId: _this.delId
}
} ).then( function ( response ) {
var result = response.data
if ( result.code === '500' ) {
_this.warnMsgShow = true
_this.warnMsg = result.msg
} else {
if ( _this.cw_type === 'dzfp' ) {
_this.dzfpList.splice( _this.index, 1 )
_this.index = -1
} else {
_this.zzfpList.splice( _this.index, 1 )
_this.index = -1
}
if ( _this.dzfpList.length === 0 ) {
_this.nodzfp = true
}
if ( _this.zzfpList.length === 0 ) {
_this.nozzfp = true
}
}
} )
.catch( function ( response ) {
console.log( response )
} )
},
onHide () {
console.log( 'on hide' )
},
onShow () {
console.log( 'on show' )
}
},
data () {
return {
warnMsgShow: false,
warnMsg: '',
startPos: 0,
endPos: 0,
currentX: 0,
index: -1,
delId: '',
fplx: '',
isMoved: false,
confirmList: [{
label: '开票单位',
value: ''
},
{
label: '开票号码',
value: ''
},
{
label: '开票金额',
value: ''
}],
pullHeight: window.innerHeight,
confirmStatus: false,
list: [{
label: '北京票通信息技术有限公司',
value: '2017-12-09'
}],
cw_type: 'dzfp',
dzfpList: [],
zzfpList: [],
nodzfp: false,
nozzfp: false,
loadingShow: false,
loadingText: '加载中'
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '我的发票' )
store.commit( 'UPDATE_SHOW_FOOTER', true )
},
created () {
var _this = this
_this.loadingShow = true
_this.$ajax.post( _this.ajaxFactory.get( 'invoiceList' ), {} ).then( function ( response ) {
var result = response.data
_this.loadingShow = false
if ( result.code === '500' ) {
_this.warnMsgShow = true
_this.warnMsg = result.msg
_this.nodzfp = true
_this.nozzfp = true
} else {
for ( var i = 0; i < result.length; i++ ) {
if ( result[i].invoiceKind === '10' || result[i].invoiceKind === '9' || result[i].invoiceKind === '08' || result[i].invoiceKind === '81' || result[i].invoiceKind === '82' ) {
_this.dzfpList.push( result[i] )
} else {
_this.zzfpList.push( result[i] )
}
}
if ( _this.dzfpList.length === 0 ) {
_this.nodzfp = true
}
if ( _this.zzfpList.length === 0 ) {
_this.nozzfp = true
}
}
} )
.catch( function ( response ) {
_this.loadingShow = false
_this.nodzfp = true
_this.nozzfp = true
console.log( response )
} )
}
}



// WEBPACK FOOTER //
// ./src/components/fpj/myfp.vue